import { render, staticRenderFns } from "./new-testimonial-row.vue?vue&type=template&id=56924146&scoped=true&"
import script from "./new-testimonial-row.vue?vue&type=script&lang=js&"
export * from "./new-testimonial-row.vue?vue&type=script&lang=js&"
import style0 from "./new-testimonial-row.vue?vue&type=style&index=0&id=56924146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56924146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56924146')) {
      api.createRecord('56924146', component.options)
    } else {
      api.reload('56924146', component.options)
    }
    module.hot.accept("./new-testimonial-row.vue?vue&type=template&id=56924146&scoped=true&", function () {
      api.rerender('56924146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/new-testimonial-row.vue"
export default component.exports